var map = {
	"./da.json": 9914,
	"./de.json": 5894,
	"./el.json": 4524,
	"./en.json": 4174,
	"./es.json": 6725,
	"./fr.json": 4605,
	"./hu.json": 6938,
	"./it.json": 3672,
	"./ja.json": 7980,
	"./pl.json": 3410,
	"./pt.json": 7741,
	"./ru.json": 4600,
	"./sv.json": 8252,
	"./tr.json": 9755,
	"./zh.json": 9527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4649;